function setFontSize(val) {
    const baseSize = 50;
    let scale = document.documentElement.clientHeight / 1080;
    let nowSize = baseSize * Math.min(scale, 2); //返回值函数内部最小的值
    return val * nowSize;
  }
  export default {
    setFontSize,
  };
  